import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

export function ConfirmDelete({ title, description, onConfirm, children, testId }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent className="border-eden-border bg-eden-surface" data-testid={`${testId}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-eden-text">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-eden-secondary">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="border-eden-border bg-transparent text-eden-text hover:bg-eden-elevated" data-testid={`${testId}-cancel`}>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-red-600 text-white hover:bg-red-700" data-testid={`${testId}-confirm`}>Eliminar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
